/* SALMOURE — comportamiento de tienda.
   Sin dependencias. Progresivo: si falla el JS, los formularios nativos siguen
   funcionando y la navegación sigue siendo enlaces reales. */
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ------------------------------------------------------------ Paneles --- */
  var lastFocus = null;

  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var target = el.querySelector('[data-autofocus]') || el.querySelector('button, a, input');
    if (target) target.focus();
  }

  function closeDrawer(el) {
    if (!el) return;
    el.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus) { lastFocus.focus(); lastFocus = null; }
  }

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-drawer-open]');
    if (open) {
      e.preventDefault();
      openDrawer(document.getElementById(open.getAttribute('data-drawer-open')));
      return;
    }
    if (e.target.closest('[data-drawer-close]') || e.target.classList.contains('drawer__veil')) {
      var d = e.target.closest('.drawer');
      if (d) { e.preventDefault(); closeDrawer(d); }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = $('.drawer[aria-hidden="false"]');
    if (open) closeDrawer(open);
  });

  /* Mantener el tabulador dentro del panel abierto */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var d = $('.drawer[aria-hidden="false"]');
    if (!d) return;
    var f = $$('a[href], button:not([disabled]), input:not([disabled]), select, textarea', d)
      .filter(function (n) { return n.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* -------------------------------------------- Acordeones / desplegables --- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-toggle]');
    if (!btn) return;
    var body = document.getElementById(btn.getAttribute('aria-controls'));
    if (!body) return;
    var open = btn.getAttribute('aria-expanded') === 'true';
    btn.setAttribute('aria-expanded', String(!open));
    if (open) body.removeAttribute('data-open');
    else body.setAttribute('data-open', '');
  });

  /* --------------------------------------------------- Galería de la PDP --- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('.gallery__track', g);
    var dots  = $$('.gallery__dot', g);
    if (!track || !dots.length) return;

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        var slide = $$('.gallery__slide', track)[i];
        if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      });
    });

    var tick;
    track.addEventListener('scroll', function () {
      clearTimeout(tick);
      tick = setTimeout(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        dots.forEach(function (d, j) { d.setAttribute('aria-current', String(j === i)); });
      }, 80);
    }, { passive: true });
  });

  /* ------------------------------------------------- Variantes de la PDP ---
     Cambia precio, disponibilidad, URL y media al elegir talla/color. */
  $$('[data-product-form]').forEach(function (form) {
    var data = document.getElementById(form.getAttribute('data-variants'));
    if (!data) return;

    var variants;
    try { variants = JSON.parse(data.textContent); } catch (err) { return; }

    var addBtn   = $('[data-add]', form);
    var idInput  = $('[data-variant-id]', form);
    var priceEl  = document.querySelector('[data-price-target]');
    var stockEl  = document.querySelector('[data-stock-target]');
    var stickyP  = document.querySelector('[data-sticky-price]');
    var money    = form.getAttribute('data-money') || '{{amount}} €';

    function format(cents) {
      var n = (cents / 100).toFixed(2).replace('.', ',');
      return money.replace('{{amount}}', n);
    }

    function selected() {
      return $$('input[data-opt]:checked', form).map(function (i) { return i.value; });
    }

    function update() {
      var chosen = selected();
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0];

      /* Marcar como no disponibles las combinaciones sin stock */
      $$('input[data-opt]', form).forEach(function (input) {
        var idx = parseInt(input.getAttribute('data-opt'), 10);
        var probe = chosen.slice();
        probe[idx] = input.value;
        var v = variants.filter(function (x) {
          return x.options.every(function (o, i) { return i === idx ? o === input.value : o === probe[i]; });
        })[0];
        input.disabled = !v || !v.available;
      });

      if (!match) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = addBtn.getAttribute('data-unavailable'); }
        return;
      }

      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.innerHTML = match.compare > match.price
        ? '<s>' + format(match.compare) + '</s>' + format(match.price)
        : format(match.price);
      if (stickyP) stickyP.textContent = format(match.price);

      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.textContent = match.available
          ? addBtn.getAttribute('data-add-label')
          : addBtn.getAttribute('data-soldout');
      }

      if (stockEl) {
        var cls = 'dot--out', txt = stockEl.getAttribute('data-out');
        if (match.available) {
          if (match.qty > 0 && match.qty <= 3) { cls = 'dot--low'; txt = (stockEl.getAttribute('data-low') || '').replace('%QTY%', match.qty); }
          else { cls = 'dot--in'; txt = stockEl.getAttribute('data-in'); }
        }
        stockEl.innerHTML = '<span class="dot ' + cls + '"></span><span>' + txt + '</span>';
      }

      /* Etiqueta visible del valor elegido */
      $$('[data-opt-value]', form).forEach(function (el) {
        var i = parseInt(el.getAttribute('data-opt-value'), 10);
        el.textContent = chosen[i] || '';
      });

      /* Reflejar la variante en la URL sin recargar */
      if (window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', match.id);
        window.history.replaceState({}, '', url.toString());
      }

      /* Llevar la galería a la imagen de la variante */
      if (match.media_index != null) {
        var track = document.querySelector('.gallery__track');
        var slide = track && $$('.gallery__slide', track)[match.media_index];
        if (slide && track.scrollWidth > track.clientWidth) {
          track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        }
      }
    }

    form.addEventListener('change', function (e) {
      if (e.target.matches('input[data-opt]')) update();
    });
    update();
  });

  /* ------------------------------------------------------ CTA fijo móvil --- */
  var sticky = $('[data-sticky-buy]');
  var buyZone = $('[data-buy-zone]');
  if (sticky && buyZone && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.boundingClientRect.top < 0 && !en.isIntersecting) sticky.setAttribute('data-show', '');
        else sticky.removeAttribute('data-show');
      });
    }, { threshold: 0 }).observe(buyZone);
  }

  /* ------------------------------------------------------ Cesta (drawer) --- */
  function refreshCart() {
    return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + '?section_id=cart-drawer' : '/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-contents]');
        var target = $('[data-cart-contents]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;

        var n = doc.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function (el) {
          if (!n) return;
          el.textContent = n.textContent;
          el.hidden = n.hidden;
        });
      });
  }

  /* Añadir a la bolsa sin salir de la página */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-product-form]');
    if (!form) return;
    e.preventDefault();

    var btn = $('[data-add]', form);
    var label = btn ? btn.textContent : '';
    if (btn) { btn.disabled = true; btn.textContent = btn.getAttribute('data-adding') || label; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: $('[data-variant-id]', form).value, quantity: 1 }]
      })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body.description || res.body.message);
        return refreshCart();
      })
      .then(function () { openDrawer(document.getElementById('cart-drawer')); })
      .catch(function (err) {
        var slot = $('[data-form-error]', form);
        if (slot) slot.textContent = err.message;
      })
      .finally(function () {
        if (btn) { btn.disabled = false; btn.textContent = label; }
      });
  });

  /* Cambiar cantidades y eliminar líneas */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-qty]');
    if (step) {
      var input = step.parentElement.querySelector('input');
      var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty'), 10));
      input.value = next;
      changeLine(input.getAttribute('data-key'), next);
      return;
    }
    var rm = e.target.closest('[data-remove]');
    if (rm) {
      e.preventDefault();
      changeLine(rm.getAttribute('data-remove'), 0);
    }
  });

  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-key]')) {
      changeLine(e.target.getAttribute('data-key'), Math.max(0, parseInt(e.target.value, 10) || 0));
    }
  });

  function changeLine(key, qty) {
    if (!key) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function () { return refreshCart(); })
      .then(function () {
        /* La página de cesta necesita recargarse para recalcular totales del tema */
        if (document.body.classList.contains('tpl-cart')) window.location.reload();
      });
  }

  /* ------------------------------------------- Orden y filtros por AJAX --- */
  var plp = $('[data-plp]');
  if (plp) {
    var applying = false;

    function loadPLP(url, push) {
      if (applying) return;
      applying = true;
      plp.style.opacity = '0.5';
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-plp]');
          if (fresh) plp.innerHTML = fresh.innerHTML;
          if (push) window.history.pushState({}, '', url);
          window.scrollTo({ top: plp.offsetTop - 120, behavior: reduce ? 'auto' : 'smooth' });
        })
        .finally(function () { plp.style.opacity = ''; applying = false; });
    }

    plp.addEventListener('change', function (e) {
      var form = e.target.closest('[data-filter-form]');
      if (!form) return;
      var params = new URLSearchParams(new FormData(form)).toString();
      loadPLP(window.location.pathname + '?' + params, true);
    });

    plp.addEventListener('click', function (e) {
      var link = e.target.closest('[data-plp-link]');
      if (!link) return;
      e.preventDefault();
      loadPLP(link.href, true);
    });

    window.addEventListener('popstate', function () { loadPLP(window.location.href, false); });
  }

  /* ------------------------------------------------------ Aparición suave --- */
  if (!reduce && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-in'); });
  }
})();
